module.exports = __webpack_public_path__ + "img/golden.a4575ca4.webp";